// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__240u8","rootMobile":"styles_rootMobile__UQxRm"};